// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"9fd56c9f","122":"7cd0ae8e"}[chunkId] + ".chunk.js";
};